import {
    FormControl,
    IterateOptions
} from '../../../../components/FormUtilities'
import SelectTouch from '../../../../components/SelectTouch'
import useGet from '../../../../hooks/useGet'
import ConsumerVoucherLabel from '../../../../models/ConsumerVoucherLabel'
import { formConsumptionVoucher } from '../../storage'
import useStowage from './useStowage'
import useSubStowage from './useSubStowage'

function Stowage() {
    const { props, stowages, handleChange, propsSearch } = useStowage()

    return (
        <FormControl label="Bodega" required>
            <SelectTouch
                {...props}
                {...propsSearch}
                onChange={handleChange}
                placeholder="Seleccionar bodega"
                label="Bodega"
            >
                <IterateOptions data={stowages} label="name" />
            </SelectTouch>
        </FormControl>
    )
}

function Tag() {
    const { props } = formConsumptionVoucher.useSelect('tag')
    const { data } = useGet<ConsumerVoucherLabel[]>(
        '/v5.6/apis/consumer_voucher_labels?is_enabled=true',
        []
    )

    return (
        <FormControl label="Etiqueta" required>
            <SelectTouch
                {...props}
                placeholder="Seleccionar etiqueta"
                label="Etiqueta"
            >
                <IterateOptions data={data.result} label="name" />
            </SelectTouch>
        </FormControl>
    )
}

function SubStowage() {
    const { props, minimalSubStowages, handleChange, propsSearch } =
        useSubStowage()

    return (
        <FormControl label="Sub bodega" required>
            <SelectTouch
                disabled
                {...props}
                {...propsSearch}
                onChange={handleChange}
                placeholder="Seleccionar sub bodega"
                label="Sub bodega origen"
            >
                <IterateOptions
                    data={minimalSubStowages}
                    label="substowage_name"
                />
            </SelectTouch>
        </FormControl>
    )
}

export default function Fields2() {
    return (
        <>
            <Stowage />
            <Tag />
            <SubStowage />
        </>
    )
}
